/* eslint-disable import/no-anonymous-default-export */
import {
  ADD_REF_USER_ERROR,
  ADD_REF_USER,
  ADD_REFCODE_ERROR,
  ADD_REFCODE,
} from '../types';

const initialState = {
  refcount: 0,
  affiliateUsers: [],
  affiliatebalance: 0,
  refcode: '',
  success: false,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_REF_USER:
      return {
        ...state,
        refcount: action.payload.totalcount,
        affiliateUsers: action.payload.affiliates,
        affiliatebalance: action.payload.affiliateEarnings,
        refcode: action.payload.refcode,
        success: true,
        loading: false,
      };
    case ADD_REF_USER_ERROR:
      return {
        ...state,
        success: false,
        loading: true,
      };
    case ADD_REFCODE:
      return {
        ...state,
        refcode: action.payload.refcode,
        success: true,
        loading: false,
      };
    case ADD_REFCODE_ERROR:
      return {
        ...state,
        success: false,
        loading: true,
      };

    default:
      return state;
  }
}
